<ng-container *ngIf="activityItems?.length > 0">
  <mat-card>
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      class="card-header"
    >
      <span class="card-title">Identity verification activity</span>
    </div>
    <mat-card-content class="card-content">
      <mat-accordion multi="true" displayMode="flat">
        <mat-expansion-panel
          *ngFor="let item of activityItems; index as i"
          class="mat-elevation-z0 panel"
        >
          <mat-expansion-panel-header class="panel-header">
            <mat-panel-title class="panel-title">
              <div class="item-container">
                <div class="item-index">
                  {{ i + 1 }}
                </div>
                <div class="item-header">
                  <div class="item-header__title">
                    {{ item.title }}
                  </div>
                  <div class="item-header__date">
                    {{ item.date | date : "medium" }}
                  </div>
                </div>
              </div>
              <button
                *ngIf="item.showActionsMenu"
                mat-icon-button
                [matMenuTriggerFor]="actionsMenu"
                (click)="$event.stopPropagation()"
                class="secondary-text"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #actionsMenu="matMenu">
                <button mat-menu-item (click)="onRefresh(item)">
                  <span>Refresh</span>
                </button>
                <button
                  mat-menu-item
                  (click)="onInvalidate(item)"
                  *ngIf="item.showInvalidateAction"
                >
                  <span>Invalidate</span>
                </button>
              </mat-menu>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <ifc-horizontal-list [items]="item.listItems">
            <ng-template horizontalListCustomTemplate="riskLevelValue">
              <div class="status-container">
                <ifc-status-label
                  [status]="IDVerseRiskLevelLabels"
                  [value]="item?.idVerseAttempt?.documentFraudAnalysis"
                ></ifc-status-label>
              </div>
            </ng-template>
            <ng-template horizontalListCustomTemplate="dataMatchingValue">
              <div class="status-container">
                <ifc-status-label
                  [status]="IDVerseOverallResultLabels"
                  [value]="item?.idVerseAttempt?.dataMatching"
                ></ifc-status-label>
              </div>
            </ng-template>
            <ng-template horizontalListCustomTemplate="livenessValue">
              <div class="status-container">
                <ifc-status-label
                  [status]="IDVerseOverallResultLabels"
                  [value]="item?.idVerseAttempt?.liveness"
                ></ifc-status-label>
              </div>
            </ng-template>
            <ng-template horizontalListCustomTemplate="faceMatchValue">
              <div class="status-container">
                <ifc-status-label
                  [status]="IDVerseOverallResultLabels"
                  [value]="item?.idVerseAttempt?.faceMatch"
                ></ifc-status-label>
              </div>
            </ng-template>
            <ng-template horizontalListCustomTemplate="reportUrlRedirectAction">
              <button
                mat-icon-button
                class="redirect-icon"
                (click)="openReportUrl(item?.idVerseAttempt?.reportUrl)"
              >
                <mat-icon>open_in_new</mat-icon>
              </button>
            </ng-template>
            <ng-template horizontalListCustomTemplate="kbaStatusValue">
              <div class="status-container">
                <ifc-status-label
                  [status]="KBAStatusLabels"
                  [value]="item?.kba?.status"
                ></ifc-status-label>
              </div>
            </ng-template>
          </ifc-horizontal-list>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-card-content>
  </mat-card>
</ng-container>
